var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.90039 6.60156H5.70039H20.1004",
    stroke: "#EC187B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3012 6.6V19.2C18.3012 19.6774 18.1115 20.1352 17.774 20.4728C17.4364 20.8104 16.9786 21 16.5012 21H7.50117C7.02378 21 6.56595 20.8104 6.22838 20.4728C5.89081 20.1352 5.70117 19.6774 5.70117 19.2V6.6M8.40117 6.6V4.8C8.40117 4.32261 8.59081 3.86477 8.92838 3.52721C9.26595 3.18964 9.72378 3 10.2012 3H13.8012C14.2786 3 14.7364 3.18964 15.074 3.52721C15.4115 3.86477 15.6012 4.32261 15.6012 4.8V6.6",
    stroke: "#EC187B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2012 11.1016V16.5016",
    stroke: "#EC187B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8008 11.1016V16.5016",
    stroke: "#EC187B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.7834cd02bd3e08fc834318399b0965d8.svg";
export { ForwardRef as ReactComponent };